"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableColumn = function (_a) {
    var className = _a.className, colSpan = _a.colSpan, children = _a.children, dusk = _a.dusk, name = _a.name;
    return (react_1.default.createElement("td", { "data-dusk": dusk, className: className, "data-name": name, colSpan: colSpan }, children));
};
exports.default = TableColumn;
//# sourceMappingURL=TableColumn.js.map